import { MessageCircle } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

export const WhatsAppButton = () => {
  const { language } = useLanguage();

  const message = language === 'es'
    ? 'Hola, me gustaría solicitar un estimado de limpieza.'
    : 'Hi, I would like to request a cleaning estimate.';

  const whatsappUrl = `https://wa.me/13233780061?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-float"
      data-testid="whatsapp-button"
      aria-label="Chat on WhatsApp"
    >
      <svg viewBox="0 0 32 32" width="28" height="28" fill="white">
        <path d="M16.004 0h-.008C7.174 0 0 7.176 0 16.004c0 3.5 1.132 6.744 3.054 9.378L1.056 31.2l6.06-1.944a15.9 15.9 0 008.888 2.688C24.824 31.944 32 24.77 32 16.004S24.826 0 16.004 0zm9.314 22.612c-.39 1.1-1.932 2.014-3.166 2.28-.844.18-1.946.324-5.656-1.216-4.746-1.968-7.8-6.786-8.034-7.1-.226-.316-1.882-2.508-1.882-4.784 0-2.274 1.192-3.392 1.614-3.856.39-.428 1.04-.618 1.662-.618.2 0 .38.01.54.018.464.02.696.048 1.002.776.382.91 1.312 3.184 1.428 3.416.116.232.232.534.082.85-.142.322-.268.464-.5.734-.232.268-.452.474-.684.764-.214.25-.454.518-.194.982.258.464 1.15 1.896 2.472 3.072 1.698 1.51 3.13 1.976 3.572 2.194.344.17.616.142.85-.088.292-.29.618-.774.95-1.254.236-.342.532-.386.894-.232.366.15 2.318 1.094 2.716 1.294.396.2.66.296.758.462.096.166.096.966-.294 2.066z"/>
      </svg>
    </a>
  );
};

export default WhatsAppButton;
